import TextInput from "components/common/custom/forms/BootTextField/TextField";
import FalconCloseButton from "components/common/FalconCloseButton";
import React, { useEffect } from "react";
import { Col, Modal, Row, Form, Button } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { updateRowData } from "../config/PriceSlice";
// import { Form } from "react-router-dom";

const EditPriceModal = ({ show, setSelectedRow, onHide, selectRow }) => {
  const dispatch = useDispatch();
  const {
    watch,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (selectRow?.id) {
      setValue("provider_code", selectRow["Provider Service Code"]);
      setValue("provider_desc", selectRow["Provider Service Description"]);
      setValue("nphies_code", selectRow["Nphies Code"]);
      setValue("price", selectRow["Price"]);
      setValue("discount", selectRow["Discount"]);
      setValue("vat", selectRow["VAT Indicator "]);
    }
  }, [selectRow]);

  const handleFormSubmit = (data) => {
    const rowNum = selectRow?.rowNum;
    if (!rowNum) return;

    // Create updated row data
    const updatedRow = {
      ...selectRow,
      "Provider Service Code": data.provider_code,
      "Provider Service Description": data.provider_desc,
      "Nphies Code": data.nphies_code,
      Price: parseFloat(data.price),
      Discount: parseFloat(data.discount),
      "VAT Indicator ": parseFloat(data.vat),
    };

    // Validate the updated row
    const errors = [];
    // ... validation logic (same as before) ...

    const isValid = errors.length === 0;

    dispatch(
      updateRowData({
        rowNum,
        updatedData: {
          ...updatedRow,
          rowNum, // Make sure to include rowNum
          isValid,
          errors,
        },
      })
    );

    onHide();
    reset();
    setSelectedRow(null);
  };

  return (
    <Modal show={show} size="lg" centered>
      <Modal.Header>
        <Modal.Title className="fs-9">Edit Price</Modal.Title>
        <FalconCloseButton
          onClick={() => {
            reset();
            onHide();
            setSelectedRow(null);
          }}
          size="sm"
          className="position-absolute top-0 end-0 me-2 mt-2"
        />
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(handleFormSubmit)}>
          <Row>
            {/* Provider Code */}
            <Col xs={12} sm={6} md={4}>
              <TextInput
                name="provider_code"
                label="Provider Service Code"
                control={control}
                size="sm"
                required={true}
                errors={errors}
                rules={{
                  required: "Provider Code is required",
                }}
              />
            </Col>

            {/* Provider Description */}
            <Col xs={12} sm={6} md={4}>
              <TextInput
                name="provider_desc"
                label="Provider Description"
                control={control}
                size="sm"
                required={true}
                errors={errors}
                rules={{
                  required: "Provider Description is required",
                }}
              />
            </Col>

            {/* Nphies Code */}
            <Col xs={12} sm={6} md={4}>
              <TextInput
                name="nphies_code"
                label="Nphies Code"
                control={control}
                size="sm"
                required={true}
                errors={errors}
                rules={{
                  required: "Nphies Code is required",
                }}
              />
            </Col>
            {/* Price */}
            <Col xs={12} sm={6} md={4}>
              <TextInput
                name="price"
                label="Price"
                control={control}
                size="sm"
                required={true}
                type="number"
                min={0}
                errors={errors}
                rules={{
                  required: "Price is required",
                  validate: (value) => {
                    const num = parseFloat(value);
                    return !isNaN(num) && num >= 0
                      ? true
                      : "Price must be a valid number >= 0";
                  },
                }}
              />
            </Col>

            {/* Discount */}
            <Col xs={12} sm={6} md={4}>
              <TextInput
                name="discount"
                label="Discount (%)"
                control={control}
                size="sm"
                required={true}
                type="number"
                min={0}
                max={100}
                errors={errors}
                rules={{
                  required: "Discount is required",
                  validate: (value) => {
                    const num = parseFloat(value);
                    if (isNaN(num)) return "Discount must be a valid number";
                    if (num < 0 || num > 100)
                      return "Discount must be between 0 and 100";
                    return true;
                  },
                }}
              />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <Controller
                name="vat"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Form.Group>
                    <Form.Label className="form-label">VAT</Form.Label>
                    <Form.Select
                      {...field}
                      size="sm"
                      value={
                        field.value === null || field.value === undefined
                          ? ""
                          : String(field.value)
                      }
                      onChange={(e) => {
                        const val = e.target.value;
                        field.onChange(val === "" ? null : parseInt(val, 10));
                      }}
                    >
                      <option value="">Select VAT</option>
                      <option value="0">VAT - 0%</option>
                      <option value="15">VAT - 15%</option>
                    </Form.Select>
                  </Form.Group>
                )}
              />
            </Col>
          </Row>

          <div className="d-flex justify-content-end mt-4">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => {
                reset();
                onHide();
                setSelectedRow(null);
              }}
              className="me-2"
            >
              Cancel
            </Button>
            <Button type="submit" size="sm" variant="primary">
              Save Changes
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditPriceModal;
